"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListingDetailsSaleHistoryDto = instanceOfListingDetailsSaleHistoryDto;
exports.ListingDetailsSaleHistoryDtoFromJSON = ListingDetailsSaleHistoryDtoFromJSON;
exports.ListingDetailsSaleHistoryDtoFromJSONTyped = ListingDetailsSaleHistoryDtoFromJSONTyped;
exports.ListingDetailsSaleHistoryDtoToJSON = ListingDetailsSaleHistoryDtoToJSON;
exports.ListingDetailsSaleHistoryDtoToJSONTyped = ListingDetailsSaleHistoryDtoToJSONTyped;
var ListingDetailsUserDto_1 = require("./ListingDetailsUserDto");
/**
 * Check if a given object implements the ListingDetailsSaleHistoryDto interface.
 */
function instanceOfListingDetailsSaleHistoryDto(value) {
    if (!('salePrice' in value) || value['salePrice'] === undefined)
        return false;
    return true;
}
function ListingDetailsSaleHistoryDtoFromJSON(json) {
    return ListingDetailsSaleHistoryDtoFromJSONTyped(json, false);
}
function ListingDetailsSaleHistoryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'salePrice': json['salePrice'],
        'buyer': json['buyer'] == null ? undefined : (0, ListingDetailsUserDto_1.ListingDetailsUserDtoFromJSON)(json['buyer']),
    };
}
function ListingDetailsSaleHistoryDtoToJSON(json) {
    return ListingDetailsSaleHistoryDtoToJSONTyped(json, false);
}
function ListingDetailsSaleHistoryDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'salePrice': value['salePrice'],
        'buyer': (0, ListingDetailsUserDto_1.ListingDetailsUserDtoToJSON)(value['buyer']),
    };
}
